import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import Login from "./pages/Login.js";
import Home from "./pages/Home.js";
import MyAccount from "./pages/MyAccount.js";
import GenerateTeams from "./pages/GenerateTeams.js";
import Members from "./pages/Members.js";
import Finance from "./pages/Finance.js";
import Vests from "./pages/Vests.js";
import Admin from "./pages/Admin.js";
import Confirm from "./pages/Confirm.js";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={ <Login />}/>
        <Route path="/home" element={<Home />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/generate-teams" element={<GenerateTeams />} />
        <Route path="/members" element={<Members />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/vests" element={<Vests />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/confirm" element={<Confirm />} />
      </Routes>
    </Router>
  );
}

export default App;
